export const getTime =
  "https://script.google.com/macros/s/AKfycbzGHMSvhJUXAW1YALAH_ZSjtPfGe7_dP4awVHE0r1h_O0dEI6ZPh_ieFy-8LaiZGPxtrw/exec";

export const getStartTime =
  "https://script.google.com/macros/s/AKfycbz24MHbi7lbGQpF5FqeL75gwB-fwWL8KLz0hXvu6zYBB7zbii8wAHNXuYQgZYhlLdWwTA/exec";

export const getRank =
  "https://script.google.com/macros/s/AKfycbw2COz8GHIdeFmsNXk_fCEoF2bjmE9aPXmO5fkNiKTdM3aJWpv9-XXvV8el7vbL94AH/exec";

export const getNoTime =
  "https://script.google.com/macros/s/AKfycbzN5EaR33ZgCXEcuERshVnucGU9a7epRZv9OJMpVjDDM6gSbwypnMkITFfGx0jVKurz/exec";
